import { render, staticRenderFns } from "./OrdersSchedules.vue?vue&type=template&id=a9a479d4&"
import script from "./OrdersSchedules.vue?vue&type=script&lang=js&"
export * from "./OrdersSchedules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports